import React from 'react';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


/**
 * Renders a search bar component.
 * @param {Object} props - The component props.
 * @param {Function} props.handleSearch - The function to handle search.
 * @returns {JSX.Element} The rendered search bar component.
 */
export default function SearchBar({handleSearch}) {


    library.add(faSearch)
    return (

        <div className='px-6'>
        <faSearch />
            <label className='text-black font-semibold'>Search Projects</label>
            <div className='relative mt-2'>
                <input id='search' className='block w-full py-2 pl-8 border
                 border-black rounded-lg text-black' placeholder='Search by name'
                    type='search' name='search' onChange={handleSearch}>
                </input>
                <i class="absolute left-2 top-2 text-black">
                    <FontAwesomeIcon icon="fas fa-search" />
                </i>
            </div>
        </div>

    )

}